module.exports = __webpack_public_path__ + "static/img/in-century-insurance.7a8969d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/in-century-insurance.png
// module id = LYWr
// module chunks = 1